
export const reqUrlParam =  "jmbaseReqUrl";